import { render, staticRenderFns } from "./LocalityCreate.vue?vue&type=template&id=23d3d0cc&scoped=true"
import script from "./LocalityCreate.vue?vue&type=script&lang=js"
export * from "./LocalityCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3d0cc",
  null
  
)

export default component.exports